<div *ngIf="infoProperty">
  <app-property-location-info
    [autoRemove]="true"
    [infoProperty]="infoProperty"
    [enabledProperties]="this.viewerService.enableProperties$ | async"
    [aois]="(this.viewerService.projectStatus$ | async)?.enabledAOIs"
    [layer]="this.layer"
    [feature]="this.feature"
    (onUpdatePropertyInfo)="onUpdatePropertyInfo($event)"
    (onUpdateDamageInfo)="onUpdateDamageInfo($event)"></app-property-location-info>
</div>
